import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";

import React, { Component } from "react";

class Payment extends Component {
  stripe = loadStripe('__REACT_APP_STRIPE_PUBLIC_KEY__',{locale:'de'});
  render() {
    return (
      <Elements stripe={this.stripe}>
        {/* <CheckoutForm /> */}
        {this.props.children}
      </Elements>
    );
  }
}

export default Payment;
